import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-identity-banner',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './parent-identity-banner.component.html',
  styleUrl: './parent-identity-banner.component.scss',
})
export class ParentIdentityBannerComponent {
  #router = inject(Router);

  inGrace = input(false);
  graceDays = input(0);
  messageKey = input('app.identity.banner.message');
  graceMessageKey = input('app.identity.banner.graceMessage');
  ctaKey = input('app.identity.banner.cta');

  readonly showGraceCountdown = computed(
    () => this.inGrace() && this.graceDays() > 0,
  );

  startVerification(): void {
    void this.#router.navigate(['/identity/verify']);
  }
}
